module.exports = __webpack_public_path__ + "img/master-photo-mobile.036b6b8b.png";